import { get } from '../Services/Api/Api';

const getUseSubscribe = async (url) => get(url);

export { getUseSubscribe };
